import styled from "styled-components";

export const PlayerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const PlayerViewport = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  overflow: hidden;
  border: 1px solid ${(props) => props.theme.black1};
  border-radius: 8px;
  background-color: ${(props) => props.theme.white1};
`;

export const PlayerSurface = styled.div`
  width: 100%;
  height: 100%;
  transform: scale(${(props) => props.$scale});
  transform-origin: center;
`;

export const ControlBar = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background-color: rgba(0, 0, 0, 0.6);
  color: ${(props) => props.theme.white1};
`;

export const ControlGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ProgressGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 200px;
`;

export const ControlLabel = styled.span`
  font-size: 12px;
`;

export const TimeLabel = styled.span`
  font-size: 12px;
  min-width: 90px;
  text-align: right;
`;

export const ControlButton = styled.button`
  height: 30px;
  padding: 0 10px;
  border: 1px solid ${(props) => props.theme.white1};
  border-radius: 6px;
  background-color: transparent;
  color: ${(props) => props.theme.white1};
  font-size: 12px;
  cursor: pointer;
`;

export const IconButton = styled.button`
  width: 32px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(props) => props.theme.white1};
  border-radius: 6px;
  background-color: transparent;
  color: ${(props) => props.theme.white1};
  font-size: 14px;
  cursor: pointer;
`;

export const ControlSelect = styled.select`
  height: 30px;
  padding: 0 8px;
  border: 1px solid ${(props) => props.theme.white1};
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.7);
  color: ${(props) => props.theme.white1};

  & option {
    color: #111111;
    background-color: #ffffff;
  }
`;

export const ZoomButton = styled.button`
  min-width: 30px;
  height: 30px;
  border: 1px solid ${(props) => props.theme.white1};
  border-radius: 6px;
  background-color: transparent;
  color: ${(props) => props.theme.white1};
  font-size: 16px;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ZoomValue = styled.span`
  min-width: 48px;
  text-align: center;
  font-size: 12px;
`;

export const ProgressInput = styled.input`
  flex: 1;
`;
